export default function PDFVEditAISupport() {
  return (
    <main className="min-h-screen bg-[#FBFAF6] text-[#26313B]">
      <section className="mx-auto max-w-3xl px-6 py-12">
        <header className="mb-8 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-[#A8720E]">
            Support – PDF Viewer &amp; Editor - AI
          </h1>
          <p className="mt-2 text-sm text-[#5B6B7C]">
            Help, troubleshooting, and contact details.
          </p>
          <p className="mt-1 text-xs text-[#8A93A2]">
            Published by <span className="font-semibold">Cosmovex</span>
          </p>
        </header>

        <div className="space-y-8 leading-relaxed text-[#3D4B59]">
          <h2 className="text-2xl font-bold text-[#A8720E]">
            Frequently Asked Questions
          </h2>

          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I open a PDF in the app?
              </h3>
              <p className="mt-1">
                Tap the file icon on the home screen to browse and open any PDF
                from your device storage. You can also open PDFs shared from
                other apps.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                What AI features are available?
              </h3>
              <p className="mt-1">
                The app includes AI Chat with PDF, AI Summarize, AI Translate,
                AI Rewrite, AI Resume Builder, AI Study Notes Generator, and AI
                PDF Generation. These features require credits which you can
                earn by signing in.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do credits work?
              </h3>
              <p className="mt-1">
                You receive free credits when you sign in with Google. Credits
                are used for AI-powered features. You can earn more credits
                through referrals or purchase additional credits via in-app
                purchase.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Can I merge or split PDFs?
              </h3>
              <p className="mt-1">
                Yes. The app supports merging multiple PDFs into one, splitting
                a PDF into individual pages, compressing PDFs, adding
                watermarks, password protection, digital signatures, and more.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Does the app work offline?
              </h3>
              <p className="mt-1">
                Core PDF tools (view, merge, split, compress, image-to-PDF,
                edit, sign) work offline. AI features and account sync require
                internet access.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Why am I seeing ads?
              </h3>
              <p className="mt-1">
                Ads help support ongoing development and keep the app free. You
                can remove ads through an in-app purchase.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I delete my account?
              </h3>
              <p className="mt-1">
                Visit our{" "}
                <a
                  href="/apps/pdfveditai/account-deletion"
                  className="text-[#0F6BBF] underline"
                >
                  Account Deletion
                </a>{" "}
                page or email us at cosmovex.apps@gmail.com with your request.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-[#A8720E]">Contact Support</h2>
          <p>
            If you need help, have feedback, or want to report an issue, email{" "}
            <a
              href="mailto:cosmovex.apps@gmail.com"
              className="text-[#0F6BBF] underline"
            >
              cosmovex.apps@gmail.com
            </a>
            . We typically respond within 24–48 hours.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Report a Bug</h2>
          <p>
            To help us resolve issues faster, include the following in your
            message:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Your device model and OS version</li>
            <li>The app version (shown in Settings)</li>
            <li>A short description of the issue</li>
            <li>Steps to reproduce the problem</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">App Information</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>App Name:</strong> PDF Viewer &amp; Editor - AI
            </li>
            <li>
              <strong>Developer:</strong> Cosmovex
            </li>
            <li>
              <strong>Contact Email:</strong>{" "}
              <a
                href="mailto:cosmovex.apps@gmail.com"
                className="text-[#0F6BBF] underline"
              >
                cosmovex.apps@gmail.com
              </a>
            </li>
            <li>
              <strong>Privacy Policy:</strong>{" "}
              <a
                href="/apps/pdfveditai/privacy-policy"
                className="text-[#0F6BBF] underline"
              >
                cosmovexapps.com/apps/pdfveditai/privacy-policy
              </a>
            </li>
            <li>
              <strong>Account Deletion:</strong>{" "}
              <a
                href="/apps/pdfveditai/account-deletion"
                className="text-[#0F6BBF] underline"
              >
                cosmovexapps.com/apps/pdfveditai/account-deletion
              </a>
            </li>
          </ul>
        </div>

        <footer className="mt-12 border-t border-[#E1DCCE] pt-4 text-center text-sm text-[#8A93A2]">
          © {new Date().getFullYear()} Cosmovex — All rights reserved.
        </footer>
      </section>
    </main>
  );
}
